import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from '@material-tailwind/react';
import { ListIcon } from 'lucide-react';
import { URLS } from '../../router-x/urls';
import { managementBranchUrl } from './urls';

const ListModeMenu = ({ branchId, branchName, buildingId } = {}) => {
  const navigate = useNavigate();

  const links = [
    {
      label: branchId ? `Buildings in ${branchName || 'branch'}` : 'All branches (list)',
      action: () => {
        if (branchId) navigate(managementBranchUrl(branchId));
        else navigate(URLS.ADMIN.MANAGEMENT);
      },
    },
    { label: 'Private offices', action: () => navigate(URLS.ADMIN.OFFICE) },
    { label: 'Seats', action: () => navigate(URLS.ADMIN.SEAT) },
  ];

  return (
    <Menu placement="bottom-end">
      <MenuHandler>
        <Button
          variant="outlined"
          size="sm"
          className="rounded-full flex items-center gap-2 normal-case font-normal"
        >
          <ListIcon size={14} />
          List mode
        </Button>
      </MenuHandler>
      <MenuList className="max-h-80 overflow-auto">
        {links.map((link) => (
          <MenuItem
            key={link.label}
            className="rounded-lg"
            onClick={link.action}
          >
            {link.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default ListModeMenu;
